import * as Request from '../../request'
import * as Constants from './constants'

const initialState = {
  fields: {
    password: '',
    username: '',
  },
  ui: {isValidating: false},
}

export const reducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case Request.requestConstant(Constants.USER_LOGIN):
      return {
        ...state,
        ...{
          ui: {
            isValidating: true,
          },
        },
      }
    case Request.errorConstant(Constants.USER_LOGIN):
      return {
        ...state,
        ...{
          ui: {
            isValidating: false,
          },
        },
      }
    case Constants.UPDATE_LOGIN_FIELD:
      return {
        ...state,
        ...{
          fields: {
            ...state.fields,
            [action.field.name]: action.field.value,
          },
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/pages/oauth-login/reducer.ts